import React from 'react';
import Image from 'common/components/Image';
import SimpleModal from '../Modal/SimpleModal';
import ModalWithTitleInner from '../Modal/ModalWithTitleInner';
import { TwitterShareButton } from 'react-share';

type Props = {
  isShowing: boolean;
  depositTokenDisplayName: string;
  vaultDisplayName: string;
  depositedValue: string;
  vaultIrr: string;
  toggle: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const DepositCompleteModalContainer: React.FC<Props> = (props) => {
  const [step, setStep] = React.useState(1);
  const vaultIrrText =
    Number(props.vaultIrr) > 0
      ? ` which has ${Number(props.vaultIrr).toFixed(
          2
        )}% 7-day APR`
      : '';
  const tweetCopy = `I deposited to the @ichifoundation ${props.vaultDisplayName} on app.ichi.org ${vaultIrrText}. #ICHI makes earning with liquidity in #DeFi easy.`;

  return (
    <SimpleModal isShowing={props.isShowing}>
      {/* ********** STEP 1: Congratulations ********** */}
      {step === 1 && (
        <ModalWithTitleInner title="Congratulation!">
          <div className="flex flex-col">
            <div className="flex flex-col items-center">
              <Image
                src="https://ichi-images.s3.amazonaws.com/misc/confetti.svg"
                marginTop="40px"
                alt="Congratulations!"
              />
              <div className="text-lg text-center mt-10 px-14">
                {'You have deposited '}
                <strong>{`${props.depositedValue} `}</strong>
                <strong>{props.depositTokenDisplayName}</strong>
                {'!'}
              </div>
            </div>
          </div>
          <div className="content-inner-bg-color rounded-[20px] p-7 flex flex-col items-center mt-7">
            <div>Excited about this opportunity?</div>
            <div
              className="flex justify-start items-center gap-3 text-xl font-medium mt-5 cursor-pointer"
              onClick={() => setStep(2)}
            >
              <Image
                src="https://ichi-images.s3.amazonaws.com/misc/X_logo.svg"
                alt="X"
                width='40px'
              />
              Share on X
            </div>
          </div>
          <div className="flex justify-center gap-3 items-center h-24 box-footer  pb-3">
            <button
              onClick={props.toggle}
              className="primary-text-color border-[1px] border-gray-200 font-semibold"
            >
              Close
            </button>
          </div>
        </ModalWithTitleInner>
      )}

      {/* ********** STEP 2: Share on Twitter ********** */}
      {step === 2 && (
        <ModalWithTitleInner title="Share on X">
          <div className="flex flex-col items-start content-inner-bg-color px-2 tablet:px-6 py-6 rounded-2xl">
            <div className="flex justify-start items-center gap-3 text-xl font-medium">
              <Image
                src="https://ichi-images.s3.amazonaws.com/misc/X_logo.svg"
                alt="X"
                width='40px'
              />
              Share this with your followers
            </div>
            <div className="text-lg text-left my-4 styled-content px-2 tablet:px-4 py-4 rounded-[10px]">
              {tweetCopy}
            </div>
            <div className="text-right w-full">
              <div className="float-right bg-[#03A9F4] px-3 py-1 rounded-[10px] text-white font-medium">
                <TwitterShareButton
                  title={tweetCopy}
                  url={'app.ichi.org'}
                  hashtags={['ichifoundation']}
                  className=""
                >
                  Share
                </TwitterShareButton>
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-3 items-center h-24 box-footer  pb-3">
            <button
              onClick={props.toggle}
              className="primary-text-color border-[1px] border-gray-200 font-semibold"
            >
              Close
            </button>
          </div>
        </ModalWithTitleInner>
      )}
    </SimpleModal>
  );
};

export default DepositCompleteModalContainer;
